import { type IPow3NewsItem, NewsItem } from "../../../network/domain/NewsItem";

export interface INewsItemMapper {
	map(pow3NewsItem: IPow3NewsItem): NewsItem;
}

export class NewsItemMapper implements INewsItemMapper {
	map(pow3NewsItem: IPow3NewsItem): NewsItem {
		const { id, created, updated, visible, header, body, language, from, until, popup, maintenance, hoursUpFront } = pow3NewsItem;

		return new NewsItem(id, header, body, from, until, popup, maintenance, created, updated, visible, language, hoursUpFront);
	}
}
